import { useEffect, useState } from "react";
import CustomActionButton from "../../../common/CustomActionButton";
import { SendEmailToTherapist } from "../../../redux/user/actions";
import { connect } from "react-redux";
import { use } from "react";
import toast from "react-hot-toast";

function TRSendEmailForm(props) {
    const {
        therapist = {},
        emailTemplate = {},
        setShowModal = () => { }
    } = props;

    const [htmlPreview, setHtmlPreview] = useState("");
    const name = `${therapist?.first_name} ${therapist?.last_name}`;
    const sender = "Indi <help@e.indimoves.com>";

    const arrangeHTMLContent = (htmlTemplate) => {
        let htmlContent = htmlTemplate;
        htmlContent = htmlContent.replaceAll("{{clinician_name}}", therapist?.first_name);
        return htmlContent;
    }

    const handlePreviewEmail = async (et = null) => {
        setHtmlPreview(arrangeHTMLContent(emailTemplate?.html_content));
    }

    const sendEmail = async () => {
        const toastID = toast.loading("Sending email...");

        const res = await props?.SendEmailToTherapist({
            htmlContent: htmlPreview,
            subject: emailTemplate?.email_subject,
            receipient: therapist?.email_address,
            sender: sender,
            userID: therapist?.id,
            emailTemplate
        });


        if (res) {
            setShowModal(false);

            toast.success("Email sent successfully", {
                id: toastID
            });


        } else {

            toast.error("Failed to send email", {
                id: toastID
            });
        }

        return res || false;
    }

    useEffect(() => {
        if (therapist?.id && emailTemplate) {
            handlePreviewEmail(emailTemplate);
        }
    }, [therapist?.id, emailTemplate]);

    return (
        <div id="tr-send-email-form">
            <div id="trsef-email-content">
                <div id="trsef-ec-to">
                    <h5>TO: </h5>
                    <h5>{name}</h5>

                    {/* <div id="trsef-actions"> */}
                    <CustomActionButton disabled={false} type={2} className="active" size="small" action={async () => {
                        return await sendEmail();
                    }}>Send</CustomActionButton>
                    {/* </div> */}
                </div>

                <div>
                    <h5>FROM: </h5>
                    <h5>{sender}</h5>
                </div>

                <div>
                    <h5>SUBJECT: </h5>
                    <h5>{emailTemplate?.email_subject}</h5>
                </div>

                <div id="trsef-email-preview">
                    {/* <div id="action-btns">
                        {
                            isEdit
                                ? <>
                                    <CustomActionButton className="active" size="small" action={saveEditedEmail}>
                                        Save
                                    </CustomActionButton>
                                    <CustomActionButton type={2} isPrimary={false} size="small" action={revertEditedEmail}>
                                        Cancel
                                    </CustomActionButton>
                                </>
                                : <CustomButton isPrimary={false} size="small" onClick={arrangeEditEmail}>
                                    Edit Email
                                </CustomButton>
                        }

                    </div> */}
                    <div className="editable" dangerouslySetInnerHTML={{ __html: htmlPreview }} />
                </div>


            </div>
        </div >
    );
}

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    SendEmailToTherapist,
})(TRSendEmailForm);